module.exports = __webpack_public_path__ + "img/home-l-b.f8bb0797.png";